import { useState, useEffect, useCallback, useRef } from 'react';
import { useForm } from "react-hook-form"
import './Board.css'

export default function Game (props) {
  const [gameInitialized, setGameInitialized] = useState(false)
  const [gameUUID, setGameUUID] = useState(JSON.parse(localStorage.getItem('gameUUID')))
  const [playerMap, setPlayerMap] = useState(Array(3).fill(null))
  const [humanPlayer, setHumanPlayer] = useState(null)
  const [isWalterP1, setIsWalterP1] = useState(false)
  const [gameWinner, setGameWinner] = useState(null)
  const [winningMove, setWinningMove] = useState([])
  const [buttonsDisabled, setButtonsDisabled] = useState(false)
  const [gameStatus, setGameStatus] = useState({'state': [Array(3).fill(0), Array(3).fill(0), Array(3).fill(0)]})
  const [availableMoves, setAvailableMoves] = useState([])
  const { register } = useForm({defaultValues: {player: "X"}})
  const playerRef = useRef()

  const api_url = 'https://api.kubernaughty.com/ttt'

  const pullGameStatus = (uuid) => {
    const promise = fetch(`${api_url}/game/getgamestatus/${uuid}`)
      .then(res => res.json())
      .then(res => {if (res.result === 'success') setGameStatus(res.status)})
    return promise
  }

  const pullAvailableMoves = (uuid) => {
    const promise = fetch(`${api_url}/game/getavailablemoves/${uuid}`)
      .then(res => res.json())
      .then(res => {if (res.result === 'success') setAvailableMoves(res.moves)})
    return promise
  }

  const pullWinningMove = (uuid) => {
    const promise = fetch(`${api_url}/game/getwinningmove/${uuid}`)
      .then(res => res.json())
      .then(res => {if (res.result === 'success') setWinningMove(res.winning_move)})
    return promise
  }

  const walterMove = useCallback(() => {
    setButtonsDisabled(true)
    fetch(`${api_url}/walter/makemove/${gameUUID}`, {
      method: 'post',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
      }})
        .then(res => res.json())
        .then(res => {
          setGameStatus(res.status)
          setAvailableMoves(res.available_moves)
        })
        .then(res => setButtonsDisabled(false))
  }, [gameUUID])

  const makeMove = useCallback((x, y) => {
    const move = [x, y]
    if (availableMoves.some(attempt => attempt.every((element, index) => Object.is(move[index], element)))) {
      setButtonsDisabled(true)
      fetch(`${api_url}/game/move/${gameUUID}`, {
      method: 'post',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
      },
      body: JSON.stringify({"move": move})})
        .then(res => res.json())
        .then(res => {
          setGameStatus(res.status)
          setAvailableMoves(res.available_moves)
          return res
        })
        .then(res => {
          setButtonsDisabled(false)
          return res
        })
        .then(res => {if (res.available_moves.length !== 0) walterMove()})
    }
  }, [availableMoves, gameUUID, walterMove])

  const initializeGame = useCallback((uuid) => {
    pullGameStatus(uuid)
    .then(pullAvailableMoves(uuid))
    .then(() => setGameInitialized(true))
    .then(() => {if (isWalterP1) walterMove()})
  }, [isWalterP1, walterMove])

  const player_initializer = player_num => {
    const player_letter = playerRef.current.player.value
    if (player_num === 2) {
      setIsWalterP1(true)
      var ai_player = 1
    } else var ai_player = 2
    
    fetch(`${api_url}/game/initializegame/${player_letter}?ai_player=${ai_player}&token=${props.token}`, {
      method: 'post',
      headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
      }})
      .then(res => res.json())
      .then(res => {if (res.result === 'success') {
        setGameUUID(res.uuid)
        setHumanPlayer(player_num)
        localStorage.setItem('gameUUID', JSON.stringify(res.uuid))
      }})
  }

  const resetGame = () => {
    localStorage.removeItem('gameUUID')
    setGameUUID(null)
    setGameInitialized(false)
    setGameWinner(null)
    setIsWalterP1(false)
    setGameStatus({})
    setAvailableMoves([])
    setWinningMove([])
  }

  useEffect(() => {
    if (gameUUID !== null) {
      initializeGame(gameUUID)
    }
  }, [gameUUID, initializeGame])

  useEffect(() => {
      setGameWinner(gameStatus.winner)
  }, [gameStatus.winner])

  useEffect(() => {
    if (gameWinner === "1" || gameWinner === "2") {
      pullWinningMove(gameUUID)
    }
}, [gameUUID, gameWinner])

  useEffect(() => {
    if (gameStatus.first_player_letter !== null) {
      if (gameStatus.first_player_letter === 'X') {
        setPlayerMap([null, 'X', 'O'])
      } else if (gameStatus.first_player_letter === 'O') {
        setPlayerMap([null, 'O', 'X'])
      }
    }
  }, [gameStatus.first_player_letter])

  return (
    <div>
      {!gameInitialized &&
      <form ref={playerRef}>
          <div className="button-holster">
            <input {...register("player")} type="radio" value="X" id="X" />
            <label htmlFor="X">X</label>
            <input {...register("player")} type="radio" value="O" id="O" />
            <label htmlFor="O">O</label>
          </div>
          <div className="button-holster">
            <input type="button" name="one" className="button" value="Start as Player 1" onClick={() => player_initializer(1)} />
            <input type="button" name="two" className="button" value="Start as Player 2" onClick={() => player_initializer(2)} />
          </div>
      </form>}
      {gameInitialized && 
      <Board 
        boardStatus={gameStatus.state}
        handleClick={makeMove}
        playerMap={playerMap}
        buttonsDisabled={buttonsDisabled}
        winningMove={winningMove}
      />}
      <div className="button-holster">
      <input type="button" name="one" className="button" value="Reset" onClick={() => resetGame()} />
      </div>
    </div>
  )
}

function Board(props) {
  const renderSquare = (x, y) => {
    const square_index = [x, y]
    return (
      <Square
        value={props.playerMap[props.boardStatus[x][y]]}
        handleClick={() => props.handleClick(x, y)}
        buttonsDisabled={props.buttonsDisabled}
        winningSquare = {props.winningMove.some(attempt => attempt.every((element, index) => Object.is(square_index[index], element))) ? true : false}
      />
    )
  }

  return (
    <div className='game'>
      <div className="board-row">
        {renderSquare(0, 0)}
        {renderSquare(0, 1)}
        {renderSquare(0, 2)}
      </div>
      <div className="board-row">
        {renderSquare(1, 0)}
        {renderSquare(1, 1)}
        {renderSquare(1, 2)}
      </div>
      <div className="board-row">
        {renderSquare(2, 0)}
        {renderSquare(2, 1)}
        {renderSquare(2, 2)}
      </div>
    </div>
  )
}

function Square(props) {
  return (
    <button className={"square" + (props.winningSquare ? ' game-won' : '')} onClick={props.handleClick} disabled={props.buttonsDisabled}>
      {props.value}
    </button>
  );
}